var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visible,"width":"555px","custom-class":"fifl-dialog","close-on-click-modal":false,"top":"20px"},on:{"update:visible":function($event){_vm.visible=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }